import React from 'react';

import {Col, Row} from 'reactstrap';

import PropTypes from 'prop-types';
import {ImageCompanyLogo} from '../Images';
import PublicCountry from './PublicCountry';
import {LabelCompanyName} from '../Labels';

class PublicCompaniesItem extends React.Component {
  static propTypes = {
    size: PropTypes.string,
    to: PropTypes.string.isRequired,
    file: PropTypes.string,
    companyType: PropTypes.oneOf(['ab', 'cb', 'ce']),
    countryName: PropTypes.string,
    companyName: PropTypes.string.isRequired,
    companyAcronym: PropTypes.string,
  };

  render() {
    const {
      size,
      to,
      file,
      companyType,
      countryName,
      companyName,
      companyAcronym,
    } = this.props;

    return (
      <Row>
        <Col xs="auto">
          <ImageCompanyLogo
            size={size}
            companyType={companyType}
            to={to}
            file={file}
          />
        </Col>

        <Col>
          <PublicCountry countryName={countryName} />
          <LabelCompanyName
            tag="h5"
            to={to}
            name={companyName}
            acronym={companyAcronym}
          />
        </Col>
      </Row>
    );
  }
}

export default PublicCompaniesItem;
